import { render, staticRenderFns } from "./LawMatterStatusList.vue?vue&type=template&id=64e28077&"
import script from "./LawMatterStatusList.vue?vue&type=script&lang=js&"
export * from "./LawMatterStatusList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterStatusList.vue?vue&type=style&index=0&id=64e28077&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports